export enum Step {
  SELECT_FILE = 'SELECT_FILE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  ADDITIONAL_REVIEW = 'ADDITIONAL_REVIEW',
  DOCUMENT_ADDED = 'DOCUMENT_ADDED',
}
